import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

export default function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-blue-900">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-blue-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img
            src="https://www.reflectiz.com/wp-content/themes/reflectiz/assets/images/sections/footer/logo.svg"
            alt="Reflectiz"
            className="h-8 mx-auto mb-6 brightness-0 invert"
          />
          <h1 className="text-4xl font-bold text-white">AMA</h1>
          <p className="mt-2 text-blue-200">
            Ask Me Anything
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-6">
            <h2 className="text-xl font-semibold text-gray-900">Welcome</h2>
            <p className="mt-2 text-sm text-gray-600">
              Sign in with your company account to submit questions and vote
            </p>
          </div>

          <button
            onClick={handleLogin}
            className="w-full bg-blue-900 text-white rounded-lg py-3 px-4 font-medium hover:bg-blue-950 transition-colors flex items-center justify-center gap-3"
          >
            <svg className="w-5 h-5" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#F25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
              <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
            </svg>
            Sign in with Microsoft
          </button>
        </div>

        <p className="mt-8 text-center text-sm text-blue-200">
          Internal use only. Unauthorized access is prohibited.
        </p>
      </div>
    </div>
  );
}
